import React from "react";
import { Button } from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
import "./nextButton.scss";
import Loader from "../loader/Loader";
import SaveIcon from "@material-ui/icons/Save";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

interface NextButtonProps {
    onClick: (event: any) => void;
    disabled?: boolean;
    disabledColor?: boolean;
    displayLoader?: boolean;
    buttonType: "next"|
        "calculate"|
        "policy"|
        "policy-direct"|
        "save-offer"|
        "save-offer-for-ef"|
        "client-ends"|
        "client-ends-contract-data";
}

export default function NextButton(props: NextButtonProps) {
    let className = "";
    let displayText = "";
    let endIcon = null;

    switch (props.buttonType) {
        case "calculate":
            className = "calculate-button";
            displayText = "Przelicz";
            break;
        case "next":
            className = "next-button";
            displayText = "Dalej";
            endIcon = <ArrowForwardIos />;
            break;
        case "policy":
            className = "next-button";
            displayText = "Wystaw polisę";
            break;
        case "policy-direct":
            className = "next-button";
            displayText = "Kupuję z obowiązkiem zapłaty";
            break;
        case "save-offer":
            className = "save-offer";
            displayText = "Zapisz ofertę";
            break;
        case "save-offer-for-ef":
            className = "save-offer-for-ef";
            displayText = "Zapisz ofertę";
            endIcon = <SaveIcon />;
            break;
        case "client-ends":
            className = "client-ends-button";
            displayText = "Sprzedaż zdalna";
            endIcon = <MailOutlineIcon />;
            break;
        case "client-ends-contract-data":
            className = "client-ends-button client-ends-contract-data-button";
            displayText = "Wyślij ofertę";
            endIcon = <MailOutlineIcon />;
            break;
    }

    return (
        <Button variant="contained"
                endIcon={endIcon}
                className={`${className} ${props.disabledColor ? "disabled" : ""}`}
                onClick={props.onClick}
                disabled={props.displayLoader || props.disabled}
        >
            {displayText}
            {props.displayLoader && <Loader />}
        </Button>
    );
}
